import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL,
 headers: {
 Authorization: `Bearer ${getToken()}`,
 "Content-Type": "application/json",
 },
});

/**
 * =========================================
 * ADMIN ACCOUNT DELETION SERVICE
 * =========================================
 */

/**
 * Get scheduled deletion requests
 * Backend endpoint:
 * GET /admin/account-deletion/requests
 */
export const fetchScheduledDeletionRequests = async () => {
 try {
 const response = await api.get("/admin/account-deletion/requests");

 return {
 status: response.status,
 data: response.data,
 };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 data: [],
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch scheduled deletion requests",
 };
 }
};

/**
 * Get pending deletion requests
 * Backend endpoint:
 * GET /admin/account-deletion/requests/pending
 */
export const fetchPendingDeletionRequests = async () => {
 try {
 const response = await api.get("/admin/account-deletion/requests/pending");

 return {
 status: response.status,
 data: response.data,
 };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 data: [],
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch pending deletion requests",
 };
 }
};

/**
 * Get cancelled deletion requests
 * Backend endpoint:
 * GET /admin/account-deletion/requests/cancelled
 */
export const fetchCancelledDeletionRequests = async () => {
 try {
 const response = await api.get("/admin/account-deletion/requests/cancelled");

 return {
 status: response.status,
 data: response.data,
 };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 data: [],
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch cancelled deletion requests",
 };
 }
};

/**
 * Get deleted deletion requests
 * Backend endpoint:
 * GET /admin/account-deletion/requests/deleted
 */
export const fetchDeletedDeletionRequests = async () => {
 try {
 const response = await api.get("/admin/account-deletion/requests/deleted");

 return {
 status: response.status,
 data: response.data,
 };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 data: [],
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch deleted deletion requests",
 };
 }
};

/**
 * Get deletion request by id
 * Backend endpoint:
 * GET /admin/account-deletion/requests/{requestId}
 */
export const fetchDeletionRequestById = async (requestId) => {
 try {
 const response = await api.get(`/admin/account-deletion/requests/${requestId}`);

 return {
 status: response.status,
 data: response.data,
 };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch deletion request details",
 };
 }
};

/**
 * Delete account immediately
 * Backend endpoint:
 * POST /admin/account-deletion/requests/{requestId}/delete-now
 */
export const deleteAccountNow = async (requestId, adminNote = "") => {
 try {
 const response = await api.post(
 `/admin/account-deletion/requests/${requestId}/delete-now`,
 { adminNote }
 );

 return {
 status: response.status,
 data: response.data,
 message: "Account deleted successfully",
 };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to delete account",
 };
 }
};

/**
 * Cancel deletion request
 * Backend endpoint:
 * POST /admin/account-deletion/requests/{requestId}/cancel
 */
export const cancelDeletionRequest = async (requestId, adminNote = "") => {
 try {
 const response = await api.post(
 `/admin/account-deletion/requests/${requestId}/cancel`,
 { adminNote }
 );

 return {
 status: response.status,
 data: response.data,
 message: "Deletion request cancelled successfully",
 };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to cancel deletion request",
 };
 }
};